module.exports = __webpack_public_path__ + "img/product_desc_sp2.3e422386.png";